<section class="search-dialog" aria-labelledby="search-dialog-title">
  <header class="dialog-header">
    <div class="dialog-heading">
      <span class="dialog-heading-icon" aria-hidden="true">
        <mat-icon>person_search</mat-icon>
      </span>
      <div class="dialog-heading-copy">
        <h2 id="search-dialog-title">Search Team Members</h2>
        <p>Find departments associated with the email addresses you enter.</p>
      </div>
    </div>
    <button type="button" class="dialog-close" (click)="close()" aria-label="Close search">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="search-content">
    <form class="email-search" (ngSubmit)="onSearch()">
      <label for="team-member-emails">Email addresses</label>
      <p class="search-hint" id="email-search-hint">Separate multiple addresses with commas (,) and semicolons (;).</p>

      <div class="search-controls">
        <div class="search-input-wrap">
          <input
            id="team-member-emails"
            name="teamMemberEmails"
            type="text"
            placeholder="name@toyota.com; name@toyota.com"
            [(ngModel)]="searchInput"
            [attr.aria-describedby]="invalidTokens.length ? 'email-search-hint email-search-error' : 'email-search-hint'"
            autocomplete="email"
          />
        </div>
        <button type="submit" class="search-button" [disabled]="isSearching || !searchInput.trim()">
          <mat-icon *ngIf="!isSearching" aria-hidden="true">search</mat-icon>
          <span *ngIf="isSearching" class="search-spinner" role="status" aria-label="Searching"></span>
          <span>{{ isSearching ? 'Searching' : 'Search' }}</span>
        </button>
      </div>

      <div *ngIf="invalidTokens.length" class="search-error" id="email-search-error" role="alert">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <span>Check these email addresses: {{ invalidTokens.join(', ') }}</span>
      </div>
    </form>

    <section class="results-section" aria-labelledby="department-results-title" aria-live="polite">
      <div class="results-heading">
        <h3 id="department-results-title">Matching departments</h3>
        <span *ngIf="hasSearched && matchedDepartments.length" class="results-count">
          {{ matchedDepartments.length }} found
        </span>
      </div>

      <div *ngIf="!hasSearched && !isSearching" class="results-empty">
        <mat-icon aria-hidden="true">manage_search</mat-icon>
        <span>Search by email to see matching departments.</span>
      </div>

      <div *ngIf="isSearching" class="results-empty results-loading">
        <span class="search-spinner" aria-hidden="true"></span>
        <span>Searching for matching departments...</span>
      </div>

      <div *ngIf="hasSearched && !isSearching && !matchedDepartments.length" class="results-empty results-no-match">
        <mat-icon aria-hidden="true">search_off</mat-icon>
        <span>No departments found for the submitted email addresses.</span>
        <p *ngIf="noMatchEmails.length">{{ noMatchEmails.join(', ') }}</p>
      </div>

      <div *ngIf="hasSearched && !isSearching && matchedDepartments.length" class="department-list">
        <article
          class="department-option"
          *ngFor="let dept of matchedDepartments"
          [class.department-option--selected]="dept.selected">
          <button
            type="button"
            class="department-select-button"
            [attr.aria-pressed]="dept.selected"
            (click)="toggleDepartment(dept)">
            <span class="department-copy">
              <span class="department-name">{{ dept.name }}</span>
              <span class="department-id">Department ID: {{ dept.id }}</span>
            </span>
            <span class="department-select-status">
              <span *ngIf="dept.isFavorite" class="favorite-indicator">
                <mat-icon aria-hidden="true">star</mat-icon>
                Favorite
              </span>
              <mat-icon class="department-selection" aria-hidden="true">
                {{ dept.selected ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
            </span>
          </button>

          <div class="department-details">
            <div class="department-detail-row" *ngIf="dept.count !== undefined">
              <span>Total members</span>
              <strong>{{ dept.count }}</strong>
            </div>

            <div class="matched-members" *ngIf="dept.members.length">
              <h4>Matching members <span>{{ dept.members.length }}</span></h4>
              <div class="matched-member" *ngFor="let member of dept.members">
                <span class="matched-member-name">{{ member.name || 'Team member' }}</span>
                <span class="matched-member-email">{{ member.email }}</span>
              </div>
            </div>
            <p class="no-matched-members" *ngIf="!dept.members.length">
              No matching member details are available.
            </p>
          </div>
        </article>
      </div>
    </section>
  </div>

  <footer class="dialog-footer">
    <span class="selection-summary" *ngIf="hasSearched && matchedDepartments.length">
      {{ hasSelectedDepartments ? 'Departments selected' : 'Select a department to continue' }}
    </span>
    <div class="footer-actions">
      <button type="button" class="cancel-button" (click)="close()">Cancel</button>
      <button type="button" class="confirm-button" [disabled]="!hasSelectedDepartments" (click)="confirm()">
        Add selected
      </button>
    </div>
  </footer>
</section>

